import { RHFTextField } from "@/shared/forms/RHF/RHFTextField";

import { FieldName } from "../CreatePointForm.constants";

interface PointTitleSectionProps {
    activeMap: Record<FieldName, boolean>;
    resetBelow: (field: FieldName) => void;
}

export const PointTitleSection = ({
    activeMap,
    resetBelow,
}: PointTitleSectionProps) => {
    // Render
    return (
        <RHFTextField
            name="title"
            label="Назва (опціонально)"
            disabled={!activeMap.title}
            onAfterChange={() => resetBelow("title")}
            size="large"
        />
    );
};
